var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);
dependencies["front/components/ProjectList/ProjectList.jinja"] = require( "front/components/ProjectList/ProjectList.jinja" );
dependencies["front/components/ProjectItem/ProjectItem.jinja"] = require( "front/components/ProjectItem/ProjectItem.jinja" );
dependencies["front/components/Project/ProjectImage.jinja"] = require( "front/components/Project/ProjectImage.jinja" );
dependencies["front/components/Project/ProjectGallery.jinja"] = require( "front/components/Project/ProjectGallery.jinja" );
dependencies["front/components/Footer/Footer.jinja"] = require( "front/components/Footer/Footer.jinja" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectBottom.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/components/ProjectList/ProjectList.jinja", false, "ProjectBottom.jinja", function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("ProjectList", t_1);
env.getTemplate("front/components/ProjectItem/ProjectItem.jinja", false, "ProjectBottom.jinja", function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("ProjectItem", t_4);
env.getTemplate("front/components/Project/ProjectImage.jinja", false, "ProjectBottom.jinja", function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("ProjectImage", t_7);
env.getTemplate("front/components/Project/ProjectGallery.jinja", false, "ProjectBottom.jinja", function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
t_10.getExported(function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
context.setVariable("ProjectGallery", t_10);
var macro_t_13 = runtime.makeMacro(
["project"], 
[], 
function (l_project, kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("project", l_project);
var t_14 = "";t_14 += "<div class=\"Project-bottom\">\n        <div class=\"Project-grid\">\n            ";
frame = frame.push();
var t_17 = runtime.memberLookup((l_project),"media");
if(t_17) {var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("m", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
t_14 += "\n                ";
if(runtime.memberLookup((t_18),"itemType") == "image") {
t_14 += "\n                    ";
t_14 += runtime.suppressValue((lineno = 11, colno = 51, runtime.callWrap(runtime.memberLookup((t_7),"ProjectImage"), "ProjectImage[\"ProjectIma\"]", context, [runtime.memberLookup((t_18),"item"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_19 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_20 = "";;
frame = frame.pop();
return new runtime.SafeString(t_20);
});
return macro_t_19;})()})])), env.opts.autoescape);
t_14 += "\n                ";
;
}
else {
if(runtime.memberLookup((t_18),"itemType") == "gallery") {
t_14 += "\n                    ";
t_14 += runtime.suppressValue((lineno = 13, colno = 55, runtime.callWrap(runtime.memberLookup((t_10),"ProjectGallery"), "ProjectGallery[\"ProjectGal\"]", context, [runtime.memberLookup((t_18),"item"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_21 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_22 = "";;
frame = frame.pop();
return new runtime.SafeString(t_22);
});
return macro_t_21;})()})])), env.opts.autoescape);
t_14 += "\n                ";
;
}
;
}
t_14 += "\n            ";
;
}
}
frame = frame.pop();
t_14 += "\n\n        </div>\n        <div class=\"u-CommonButtonWrapper\">\n            <button class=\"u-CommonButton Project-button\">";
t_14 += runtime.suppressValue((lineno = 19, colno = 60, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Заказать проект"])), env.opts.autoescape);
t_14 += "</button>\n        </div>\n\n        ";
if(env.getFilter("length").call(context, runtime.memberLookup((l_project),"relatedProjects"))) {
t_14 += "\n            <div class=\"Project-relevant\">\n                <h2 class=\"Project-subHeader u-Heading-2\">";
t_14 += runtime.suppressValue((lineno = 24, colno = 60, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Релевантные проекты"])), env.opts.autoescape);
t_14 += "</h2>\n\n                <div class=\"Project-projectList\">\n                    ";
t_14 += runtime.suppressValue((lineno = 27, colno = 49, runtime.callWrap(runtime.memberLookup((t_1),"ProjectList"), "ProjectList[\"ProjectLis\"]", context, [runtime.makeKeywordArgs({"caller": (function (){var macro_t_23 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_24 = "";t_24 += "\n                        ";
frame = frame.push();
var t_27 = runtime.memberLookup((l_project),"relatedProjects");
if(t_27) {var t_26 = t_27.length;
for(var t_25=0; t_25 < t_27.length; t_25++) {
var t_28 = t_27[t_25];
frame.set("r", t_28);
frame.set("loop.index", t_25 + 1);
frame.set("loop.index0", t_25);
frame.set("loop.revindex", t_26 - t_25);
frame.set("loop.revindex0", t_26 - t_25 - 1);
frame.set("loop.first", t_25 === 0);
frame.set("loop.last", t_25 === t_26 - 1);
frame.set("loop.length", t_26);
t_24 += "\n                            ";
t_24 += runtime.suppressValue((lineno = 29, colno = 57, runtime.callWrap(runtime.memberLookup((t_4),"ProjectItem"), "ProjectItem[\"ProjectIte\"]", context, [t_28,{"modifiers": ["project"]},runtime.makeKeywordArgs({"caller": (function (){var macro_t_29 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_30 = "";;
frame = frame.pop();
return new runtime.SafeString(t_30);
});
return macro_t_29;})()})])), env.opts.autoescape);
t_24 += "\n                        ";
;
}
}
frame = frame.pop();
t_24 += "\n                    ";
;
frame = frame.pop();
return new runtime.SafeString(t_24);
});
return macro_t_23;})()})])), env.opts.autoescape);
t_14 += "\n                </div>\n            </div>\n        ";
;
}
t_14 += "\n\n        ";
env.getTemplate("front/components/Footer/Footer.jinja", false, "ProjectBottom.jinja", function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_31.render(context.getVariables(), frame, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
t_14 += t_32
t_14 += "\n    </div>\n    ";
t_14 += runtime.suppressValue((lineno = 38, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
t_14 += "\n";
})});
frame = frame.pop();
return new runtime.SafeString(t_14);
});
context.addExport("ProjectBottom");
context.setVariable("ProjectBottom", macro_t_13);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["ProjectBottom.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Project/ProjectBottom.jinja
// module id = 67
// module chunks = 0